import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function CallIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 13 13" htmlColor={Color.DetailsInput} {...props}>
      <path d="M9.536 10.725q-1.33 0-2.673-.618a8.5 8.5 0 0 1-2.47-1.746 8.6 8.6 0 0 1-1.74-2.467q-.62-1.34-.619-2.67a.486.486 0 0 1 .494-.499h1.535a.51.51 0 0 1 .488.404l.27 1.384a.8.8 0 0 1-.012.332.5.5 0 0 1-.143.232L3.579 6.135q.262.48.6.91.337.428.73.818A8.1 8.1 0 0 0 6.673 9.2L7.73 8.135a.6.6 0 0 1 .268-.16.8.8 0 0 1 .326-.024l1.307.267a.55.55 0 0 1 .29.181.46.46 0 0 1 .113.306v1.526a.486.486 0 0 1-.499.494Z" />
    </MuiSvgIcon>
  );
}
export default CallIcon;
